import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { mapJSONToCompleteness } from './mappings/mapJSONToCompleteness'

type TRecalculateCompletenessProcedureParams = {
  partnerId: string
  fYear: number
  ownerId: string
}

type Response = {
  Rows: { Completeness: string }[]
}

export const recalculateCompletenessProcedure = async ({
  fYear,
  partnerId,
  ownerId,
}: TRecalculateCompletenessProcedureParams) => {
  const url = proxy('/webservice/621/sp/v3/spJBPCalculateCompleteness/call')
  const [accessToken] = await getTokens(ownerId)
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
  }

  const response = (await Rest.post({ url, payload, headers })) as Response
  return mapJSONToCompleteness(response.Rows[0].Completeness)
}
